export default "__VITE_ASSET__Dxplx7jK__"